/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

@Injectable()
export class FileService {
  constructor(private readonly httpClient: HttpClient) {}

  downloadFile(url: string) {
    // const options = new RequestOptions({responseType: ResponseContentType.Blob });
    const headers = new HttpHeaders();
    headers.append('Accept', 'text/plain');
    this.httpClient
      .get(url, { headers: headers, responseType: 'blob', observe: 'response' })
      .subscribe((res) => {
        const fileName = this.getFileNameFromResponseContentDisposition(res);
        this.saveFile(res.body, fileName);
      });
  }

  /**
   * Saves a file by opening file-save-as dialog in the browser
   * using file-save library.
   * @param blobContent file content as a Blob
   * @param fileName name file should be saved as
   */
  saveFile(blobContent: Blob, fileName: string) {
    const blob = new Blob([blobContent], { type: 'application/octet-stream' });
    saveAs(blob, fileName);
  }

  /**
   * Derives file name from the http response
   * by looking inside content-disposition
   * @param res http Response
   */
  getFileNameFromResponseContentDisposition(res: HttpResponse<Blob>) {
    const contentDisposition = res.headers.get('Content-Disposition') || '';
    const matches = /filename=([^;]+)/gi.exec(contentDisposition);
    return (matches[1] || 'untitled').trim();
  }
}
